import Vue from "vue";
import Router from "vue-router";
import sso from "@/server/sso";
import routerData from "./routerData";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login/Login.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "登录",
      },
    },
    {
      path: "/cassso",
      name: "cassso",
      component: () => import("@/views/login/cassso.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "单点登录",
      },
    },
    {
      path: "/loginSsO",
      name: "loginSsO",
      component: () => import("@/views/login/loginSso.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "迈越单点登录",
      },
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      component: () => import("@/views/forgetPassword/ForgetPassword.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "忘记密码",
      },
    },
    {
      path: "/phoneLogin",
      name: "phoneLogin",
      component: () => import("@/views/forgetPassword/phoneLogin.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "手机登录",
      },
    },
    {
      path: "/previewFilePage",
      name: "/previewFilePage",
      component: () => import("@/views/previewFilePage/previewFilePage.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        title: "文件预览",
      },
    },
    {
      path: "/error",
      name: "/error",
      component: () => import("@/views/error/Error.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        title: "error",
      },
    },
    {
      path: "/401",
      name: "401",
      component: () => import("@/views/error/401.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        title: "error",
      },
    },
    {
      path: "/403",
      name: "403",
      component: () => import("@/views/error/403.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        title: "error",
      },
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/error/404.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        noLogin: true,
        title: "error",
      },
    },
    {
      path: "/500",
      name: "500",
      component: () => import("@/views/error/500.vue"),
      meta: {
        showHeader: false,
        showFooter: false,
        title: "error",
      },
    },
    ...routerData,
  ],
});

router.beforeEach((to, from, next) => {
  // 迈越单点
  let ssoCode = "";
  let href = to.fullPath;
  let codeIndex = href.indexOf("code=") && href.indexOf("code=") + 5;
  let ind = href.indexOf("&");
  ssoCode = href.substring(codeIndex, ind);
  if (href.indexOf("code") > 0) {
    // router.push("/loginSsO");
    window.sessionStorage.setItem("loginSsoCode", ssoCode);
    router.push({ path: "/loginSsO" });
    return;
  }
  const config = JSON.parse(window.sessionStorage.getItem("setConfig"));
  if (
    sessionStorage.getItem("nz_access_token") + "" == "null" ||
    sessionStorage.getItem("nz_access_token") + "" == ""
  ) {
    const allowPath = ["/forgetPassword", "/previewFilePage", "/phoneLogin"];
    if (!allowPath.includes(to.path)) {
      if (
        to.path == "/login" ||
        to.path == "/cassso" ||
        to.path == "/loginSsO"
      ) {
        next();
      } else {
        if (config && config.isOpenCassso) {
          window.location.href = config.ssoLogin;
        } else {
          router.push("/login");
        }
      }
    } else {
      next();
    }
  } else {
    const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
    const roleCodes = userData.roleCodes || [];
    const loginFrom = sessionStorage.getItem("loginFrom");
    if (loginFrom == "cassso" && to.path == "/login") {
      // sessionStorage.removeItem('nz_access_token')
      // sessionStorage.clear();
      // alert('测试弹窗')
      setTimeout(() => {
        if (config && config.isOpenCassso) {
          window.location.href = config.ssoLogout;
        } else {
          router.push("/login");
        }
      }, 500);
    } else {
      next();
    }
  }
});

export default router;
